<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link" to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link"
                to="/AgentInfo">ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link>
            </li>
            <li class="breadcrumb-item router-link active">
              ขอเปลี่ยนแปลงข้อมูลตัวแทน
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
          ขอเปลี่ยนแปลงข้อมูลตัวแทน
        </div>
      </div>
      <div class="col">
        <div class="title d-none d-lg-block border-bottom font-family blue-1">
          ขอเปลี่ยนแปลงข้อมูลตัวแทน
        </div>
        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                ชื่อ - นามสกุล (ภาษาไทย)
                <img v-if="show" src="@/assets/images/checked.svg" class="svg-checked" />
              </div>
              <router-link to="" class="icon-pencil-disabled">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </router-link>
            </div>
            <div v-if="ShowNameTH">
              <div class="gray-3 fs-5 mt-1 font-family">
                {{ this.FullNameTH }}
              </div>
            </div>
          </div>
        </div>

        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                ชื่อ - นามสกุล (ภาษาอังกฤษ)
                <img v-if="this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/EditNameEng', this.$store.state.EditAgentInfo.CHANGE_ENG.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS">
              <div class="gray-3 fs-5 mt-1 font-family">
                {{ this.$store.state.EditAgentInfo.CHANGE_ENG.EPRENAME }}
                {{ this.$store.state.EditAgentInfo.CHANGE_ENG.ENAME }}
                {{ this.$store.state.EditAgentInfo.CHANGE_ENG.ESURNAME }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                เบอร์มือถือ
                <img v-if="this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.SUCCESS" src="@/assets/images/checked.svg" class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2" @click="ChechCreateJob('/EditMobilePhone', this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.SUCCESS">
              <div class="gray-3 fs-5 mt-1 font-family">
                {{ this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.MOBILE_PHONE }}
              </div>
            </div>
          </div>
        </div>

        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                อีเมล
                <img v-if="this.$store.state.EditAgentInfo.CHANGE_EMAIL.SUCCESS" src="@/assets/images/checked.svg" class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2" @click="ChechCreateJob('/EditEmail', this.$store.state.EditAgentInfo.CHANGE_EMAIL.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.EditAgentInfo.CHANGE_EMAIL.SUCCESS">
              <div class="gray-3 fs-5 mt-1 font-family">
                {{ this.$store.state.EditAgentInfo.CHANGE_EMAIL.EMAIL }}
              </div>
            </div>
          </div>
        </div> -->

        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                ที่อยู่
                <img v-if="this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/AgentAddress', this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div class="bg-light">
              <div v-if="this.$store.state.AddressHome !== '' && this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS"
                class="d-flex align-items-center mt-2 p-1 font-family">
                <div class="gray-3 fs-5">
                  ที่อยู่ติดต่อ <br>
                  <label>{{ this.$store.state.AddressHome }}</label><br />
                  <label style="font-family: monospace; font-size: 13px;">{{ this.$store.state.AddressHomeTele
                  }}</label>
                </div>
              </div>
              <div v-if="this.$store.state.AddressCont !== '' && this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS"
                class="d-flex align-items-center p-1 font-family">
                <div class="gray-3 fs-5">
                  ที่อยู่ตามทะเบียนบ้าน <br>
                  <label>{{ this.$store.state.AddressCont }}</label><br />
                  <label style="font-family: monospace; font-size: 13px;">{{ this.$store.state.AddressContTele
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 blue-1 fs-5 mt-1 font-family">
                บัญชีธนาคาร
                <img v-if="this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/EditBankAccount', this.$store.state.EditAgentInfo.CHANGE_BANK.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS">
              <div class="d-flex align-items-center mt-1 p-1 font-family">
                <div class="gray-3 fs-5">
                  เลขที่บัญชี : <br>
                  <div class="blue-1">
                    <label style="font-family: monospace; font-size: 13px;">{{
                      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_NO }}</label>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center mt-1 p-1 font-family">
                <div class="gray-3 fs-5">
                  ธนาคาร กรุงเทพ สาขา : <br>
                  <div class="blue-1 fs-5">
                    <label>{{ this.$store.state.BranchName }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                บันทึก VAT
                <img v-if="this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/EditVat', this.$store.state.EditAgentInfo.CHANGE_VAT.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
          </div>
        </div>

        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                ขอเปลี่ยนแปลงอื่น ๆ
                <img v-if="show" src="@/assets/images/checked.svg" class="svg-checked" />
              </div>
              <router-link to="" class="icon-pencil-disabled">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </router-link>
            </div>
          </div>
        </div>

        <div class=" blue-1 pb-3 mt-2 fw-normal fs-4 position-relative font-family">
          <label v-if="
            this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS ||
            this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS
          ">กรุณาตรวจสอบข้อมูลที่ขอแก้ไขก่อนกดปุ่ม แนบเอกสาร</label>
          <label v-else>กรุณาตรวจสอบข้อมูลที่ขอแก้ไขก่อนกดปุ่ม ส่งข้อมูล
          </label>
        </div>

        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button type="button" class="btn btn-light btn-cancel font-family-bla d-inline-block" data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <button v-if="
              this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS ||
              this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS ||
              this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS
            " type="button" class="btn btn-continue font-family-bla d-inline-block" data-bs-toggle="modal"
              data-bs-target="#staticBackdrop">
              แนบเอกสาร
            </button>
            <button v-else type="button" class="btn btn-continue font-family d-inline-block" @click="Submit()">
              ส่งข้อมูล
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade font-family" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light fw-normal popup_cancel" data-bs-dismiss="modal">
            ไม่ต้องการ
          </button>
          <router-link to="/AgentInfo">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal"
              @click="ResetState()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content font-family">
        <div class="modal-header">
          <h1 class="modal-title fs-4 blue-1" id="staticBackdropLabel">
            กรุณาแนบหลักฐาน
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body fw-normal fs-5">
          <div class="gray-3">ท่านได้ทำการขอเปลี่ยนแปลงรายการข้อมูลดังนี้</div>
          <div v-if="this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS" class="blue-1 ms-2">
            <img src="@/assets/images/icon-checked.svg" class="mb-1 pe-1"
              style="width: 25px; border-radius: 50%; cursor: pointer" />เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาอังกฤษ)
          </div>
          <div v-if="this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS" class="blue-1 ms-2">
            <img src="@/assets/images/icon-checked.svg" class="mb-1 pe-1"
              style="width: 25px; border-radius: 50%; cursor: pointer" />เปลี่ยนแปลงบัญชีธนาคาร
          </div>
          <div v-if="this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS" class="blue-1 ms-2">
            <img src="@/assets/images/icon-checked.svg" class="mb-1 pe-1"
              style="width: 25px; border-radius: 50%; cursor: pointer" />บันทึก VAT
          </div>
          <div>
            <label>กรุณากด</label><label
              class="blue-1 ps-1 pe-1">"แนบไฟล์"</label><label>เพื่อแนบหลักฐานการเปลี่ยนแปลงดังต่อไปนี้</label>
          </div>
          <div>
            <ul>
              <li v-if="this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS" class="ps-2 blue-1">
                <label>สำเนาบัตรประจำตัวประชาชน</label>
              </li>
              <li v-if="this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS" class="ps-2 blue-1">
                <label>หน้าสมุดบัญชีเงินฝากธนาคาร กรุงเทพ จำกัด (มหาชน)
                  ประเภทสะสมทรัพย์</label>
              </li>
              <li v-if="this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS" class="ps-2 blue-1">
                <label>ภ.พ.01 / ภ.พ.20</label><span class="required">*</span>
              </li>
            </ul>
          </div>
          <div>
            <label>(ประเภทไฟล์ jpg / jpeg / png / pdf / ขนาดไม่เกิน 4 MB)</label>
          </div>

          <div v-if="this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS" class="shadow-none p-3 mb-1 bg-light rounded">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ สำเนาบัตรประจำตัวประชาชน</label>
              <button type="button" class="border-0 bg-light" @click="FileChangeEng($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="FileChangeEng" style="display: none" @change="onFileChangeEng($event)" />
            </div>

            <div v-if="this.UploadFileEng != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ FileEng.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFileEng()" />
            </div>
          </div>

          <div v-if="this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS" class="shadow-none p-3 mb-1 bg-light rounded">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ หน้าสมุดบัญชีเงินฝากธนาคาร กรุงเทพ</label>
              <button type="button" class="border-0 bg-light" @click="FileImportBank($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="uploader" id="UploaderFile" style="display: none"
                @change="onFileChangeBank($event)" />
            </div>

            <div v-if="this.UploadFileBank != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ FileBank.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFileBank()" />
            </div>
          </div>

          <div v-if="this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS" class="shadow-none p-3 mb-1 bg-light rounded">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ ภ.พ.01 / ภ.พ.20</label>
              <button type="button" class="border-0 bg-light" @click="FileImportVat($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="uploadervat" style="display: none" @change="onFileChangeVat($event)" />
            </div>

            <div v-if="this.UploadFileVat != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ FileVat.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFileVat()" />
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary fs-5" data-bs-dismiss="modal">
            แก้ไข
          </button>
          <button type="button" class="btn btn-primary fs-5" data-bs-dismiss="modal" @click="CheckEnter()">
            ส่งข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "AgentInfoView",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5,
  },
  data() {
    return {
      faCircleXmark: faCircleXmark,
      UploadFile: null,
      ArrayFile: [],
      ShowAccBank: false,
      FullNameTH: '',
      FullNameENG: '',
      MobilePhone: '',
      Email: '',
      AccNo: '',
      BranchBank: '',
      Loading: true,
      UploadFileBank: null,
      FileBank: '',
      UploadFileVat: null,
      FileVat: '',
      UploadFileEng: null,
      FileEng: '',
      show: false,
      ShowNameTH: false
    };
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/UserInfo", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
      this.$store.state.AgentInfo.PRENAME = res.data.PRENAME;
      this.$store.state.AgentInfo.NAME = res.data.NAME;
      this.$store.state.AgentInfo.SURNAME = res.data.SURNAME;
      this.$store.state.AgentInfo.EPRENAME = res.data.EPRENAME;
      this.$store.state.AgentInfo.ENAME = res.data.ENAME;
      this.$store.state.AgentInfo.ESURNAME = res.data.ESURNAME;
      this.$store.state.AgentInfo.MOBILE_PHONE = res.data.MOBILE_PHONE;
      this.$store.state.AgentInfo.EMAIL = res.data.EMAIL;

      this.$store.state.AgentInfo.ADDRESS = [];
      res.data.ADDRESS.forEach(val => {
        this.$store.state.AgentInfo.ADDRESS.push(val);
      });

      this.$store.state.AgentInfo.ACC_NO = this.FormatAccNo(res.data.ACC_NO, "กรุงเทพ");
      this.$store.state.AgentInfo.ACC_BRANCH = res.data.ACC_BRANCH.replace("สาขา", "");

      this.Loading = false;
    }).catch((error) => { this.Loading = false; });

    http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
      if (response.status == 200) {
        this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
        this.$store.state.AgentCode = response.data.AGENTCODE;
      }
      else {
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => {
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
      }).then(() => {
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });
  },
  methods: {
    CheckEnter() {
      this.Loading = true;
      if (this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS && this.$store.state.EditAgentInfo.CHANGE_ENG.FILE.FILE === '') {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ สำเนาบัตรประจำตัวประชาชน</label>',
        });
        this.Loading = false;
      }
      else if (this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS && this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_DOC.FILE === '') {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ หน้าสมุดบัญชีเงินฝากธนาคาร กรุงเทพ</label>',
        });
        this.Loading = false;
      }
      else if (this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS && this.$store.state.EditAgentInfo.CHANGE_VAT.VAT_DOC.FILE === '') {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ ภ.พ.01 / ภ.พ.20</label>',
        });
        this.Loading = false;
      }
      else {
        this.$store.state.EditAgentInfo.AGENTCODE = this.$store.state.AgentCode;
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        http.post("AgencyERequest/EditAgentInfo", this.$store.state.EditAgentInfo, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          if (res.status == 200) {
            this.Loading = false;
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'บันทึกข้อมูลสำเร็จ',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {

              let tel = [];
              if (this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS ||
                this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS ||
                this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS) {
                tel.push('8556');
              }
              if (this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS) {
                tel.push('8558');
              }

              this.ResetState();
              this.$router.push({
                path: '/FinishAgentInfoView',
                query: { tel: tel.join(',') }
              });

            });
          }
          else {
            this.Loading = false;
            Swal.fire({
              icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
            });
          }
        }).catch((error) => {
          this.Loading = false;
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
          });
        });
      }
    },
    FileImportBank(e) {
      this.$refs.uploader.click();
    },
    onFileChangeBank(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</label>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</label>',
        });
      }
      else {
        this.UploadFileBank = files[0];
        if (this.UploadFileBank != undefined || this.UploadFileBank != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_DOC.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFileBank);

          this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_DOC.FILE_TYPE = this.UploadFileBank.type;
          this.FileBank = this.UploadFileBank;
        }
      }
    },
    DelectFileBank() {
      this.UploadFileBank = null;
      this.FileBank = '';
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_DOC.FILE = '';
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_DOC.FILE_TYPE = '';

      this.$refs.uploader.value = null;
    },
    FileImportVat(e) {
      this.$refs.uploadervat.click();
    },
    onFileChangeVat(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</label>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</label>',
        });
      }
      else {
        this.UploadFileVat = files[0];
        if (this.UploadFileVat != undefined || this.UploadFileVat != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.EditAgentInfo.CHANGE_VAT.VAT_DOC.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFileVat);

          this.$store.state.EditAgentInfo.CHANGE_VAT.VAT_DOC.FILE_TYPE = this.UploadFileVat.type;
          this.FileVat = this.UploadFileVat;
        }
      }
    },
    DelectFileVat() {
      this.UploadFileVat = null;
      this.FileVat = '';
      this.$store.state.EditAgentInfo.CHANGE_VAT.VAT_DOC.FILE = '';
      this.$store.state.EditAgentInfo.CHANGE_VAT.VAT_DOC.FILE_TYPE = '';

      this.$refs.uploadervat.value = null;
    },
    FileChangeEng(e) {
      this.$refs.FileChangeEng.click();
    },
    onFileChangeEng(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</label>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</label>',
        });
      }
      else {
        this.UploadFileEng = files[0];
        if (this.UploadFileEng != undefined || this.UploadFileEng != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.EditAgentInfo.CHANGE_ENG.FILE.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFileEng);

          this.$store.state.EditAgentInfo.CHANGE_ENG.FILE.FILE_TYPE = this.UploadFileEng.type;
          this.FileEng = this.UploadFileEng;
        }
      }
    },
    DelectFileEng() {
      this.UploadFileEng = null;
      this.FileEng = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.FILE.FILE = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.FILE.FILE_TYPE = '';

      this.$refs.FileChangeEng.value = null;
    },
    Submit() {
      this.Loading = true;
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      this.$store.state.EditAgentInfo.AGENTCODE = this.$store.state.AgentCode;
      http.post("AgencyERequest/EditAgentInfo", this.$store.state.EditAgentInfo, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
        if (res.status == 200) {
          this.Loading = false;
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'บันทึกข้อมูลสำเร็จ',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.ResetState();
            this.$router.push('/FinishAgentInfoView');
          });
        }
        else {
          this.Loading = false;
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
          });
        }
      }).catch((error) => {
        this.Loading = false;
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
        });
      });
    },
    FormatAccNo(Num, Bank) {
      switch (Bank) {
        case "กรุงเทพ":
          Num = Num.slice(0, 3) + "-" + Num.slice(3, 4) + "-" + Num.slice(4, 9) + "-" + Num.slice(9, 10);
          break;
        default:
          Num = Num;
          break;
      }
      return Num;
    },
    ResetState() {
      this.$store.state.EditAgentInfo.CHANGE_THI.PRENAME = '';
      this.$store.state.EditAgentInfo.CHANGE_THI.NAME = '';
      this.$store.state.EditAgentInfo.CHANGE_THI.SURNAME = '';
      this.$store.state.EditAgentInfo.CHANGE_THI.SUCCESS = false;

      this.$store.state.EditAgentInfo.CHANGE_ENG.EPRENAME = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.ENAME = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.ESURNAME = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.SUCCESS = false;
      this.$store.state.EditAgentInfo.CHANGE_ENG.FILE.FILE = '';
      this.$store.state.EditAgentInfo.CHANGE_ENG.FILE.FILE_TYPE = '';

      this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.MOBILE_PHONE = '';
      this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.SUCCESS = false;

      this.$store.state.EditAgentInfo.CHANGE_EMAIL.EMAIL = '';
      this.$store.state.EditAgentInfo.CHANGE_EMAIL.SUCCESS = false;

      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_NO = '';
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BANK = '';
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_BRANCH = '';
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_DOC.FILE = '';
      this.$store.state.EditAgentInfo.CHANGE_BANK.ACC_DOC.FILE_TYPE = '';
      this.$store.state.EditAgentInfo.CHANGE_BANK.SUCCESS = false;

      this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS = [];
      this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS = false;

      this.$store.state.EditAgentInfo.CHANGE_VAT.VAT_DOC.FILE = '';
      this.$store.state.EditAgentInfo.CHANGE_VAT.VAT_DOC.FILE_TYPE = '';
      this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS = false;
    },
    ChechCreateJob(To, SUBJOB) {
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      let request = {
        AGENTCODE: [],
        SUBJOB: SUBJOB
      };

      //this.$router.push(To);

      http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
        if (res.status == 200) {
          if (res.data !== '001' && res.data !== '002') {
            this.$router.push(To);
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
            });

            this.$router.push("/AgenteService");
          }
        }
      }).catch((error) => { });
    },
    ValidateFileType(Type) {
      if (Type !== "image/png" && Type !== "image/jpeg" && Type !== "application/pdf" && Type !== "image/jpg") {
        return false;
      }
      else {
        return true;
      }
    }
  },
};
</script>

<style scoped>
.font-family-bla {
  font-family: "DB Heavent";
}
</style>